import {
  NewStressCheckData,
  ActionType,
} from "models/stressCheck/newStressCheck";
import { IResponse } from "models";

export const newStressCheckAction = (payload: NewStressCheckData) => {
  return {
    type: ActionType.NEW_STRESS_CHECK,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.NEW_STRESS_CHECK_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.NEW_STRESS_CHECK_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.RESET_NEW_STRESS_CHECK,
  };
};
